import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from '../../services/viewport.service';
import { dividerBackgroundColor } from '../../types/divider-background-color.type';
import { IN_PERSON_ASSISTANCE_LINK } from '../../constants/in-person-assistance-link.constant';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  private isDesktopSubscription: Subscription;
  public readonly digitalAssistanceLink = 'http://ipesaude.rs.gov.br/atendimento-digital';
  public readonly dividerBackgroundColor: dividerBackgroundColor = 'highlight-grey-darkest';
  public isDesktop: boolean;

  get inPersonAssistanceLink(): string {
    return IN_PERSON_ASSISTANCE_LINK;
  }

  get bottomImageFilePath(): string {
    const assetsPath = './assets/images';
    const desktopFilePath = `${assetsPath}/Procergs-Desktop.svg`;
    const mobileFilePath = `${assetsPath}/Procergs-Mobile.svg`;

    return this.isDesktop ? desktopFilePath : mobileFilePath;
  }

  constructor(private viewportService: ViewportService) {}

  ngOnInit(): void {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
  }

  ngOnDestroy(): void {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }
  }
}
